import { useMutation, type MutationHookOptions } from '@apollo/client';
import { graphql } from '@/gql/__codegen__';
import type {
  UserCreate_SendEmailVerificationCodeMutation,
  UserCreate_SendEmailVerificationCodeMutationVariables,
} from '@/gql/__codegen__/graphql';

const MUTATION = graphql(`
  mutation userCreate_sendEmailVerificationCode($emailAddress: String!) {
    sendEmailVerificationCode(emailAddress: $emailAddress) {
      status
      token
      hash
    }
  }
`);

type HookOptions = MutationHookOptions<
  UserCreate_SendEmailVerificationCodeMutation,
  UserCreate_SendEmailVerificationCodeMutationVariables
>;

export function useSendEmailVerificationCodeMutation(options?: HookOptions) {
  return useMutation(MUTATION, options);
}
